import React from 'react';
import { MenuItem, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import PropTypes from 'prop-types';
import NavDropdownCustom from './NavDropdownCustom';

export default function NavDropdownMenu(props) {
    const renderTitle = () => {
        return (
            <span>
                <span className="navigationTitle">{props.title}</span>
                {props.subTitle ? <span className="navigationSubTitle">{props.subTitle}</span> : null}
            </span>
        );
    };
    const getNavDropdown = () => {
        return (
            <NavDropdownCustom
                onSelect={props.onSelect}
                title={renderTitle()}
                id={`nav-dropdown-${props.title}`}
                disableMouseOver={props.disableMouseOver}
                comp={props.comp}
                className={props.className}
            >
                {props.urls.map((u) => (
                    <LinkContainer
                        key={u.id}
                        to={`${props.baseUrl}/${u.link}`}
                        exact={u.exact}
                        isActive={props.highlightActiveItem === true ? undefined : () => false}
                    >
                        <MenuItem>{u.title}</MenuItem>
                    </LinkContainer>
                ))}

                {props.additionalItems}
            </NavDropdownCustom>
        );
    };

    if (props.isSmallScreen) {
        return <Nav className="sub-nav">{getNavDropdown()}</Nav>;
    }
    return <LinkContainer to={props.baseUrl}>{getNavDropdown()}</LinkContainer>;
}

NavDropdownMenu.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    title: PropTypes.any.isRequired,
    highlightActiveItem: PropTypes.bool,
    isSmallScreen: PropTypes.bool,
    urls: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired,
            exact: PropTypes.bool.isRequired,
            isActive: PropTypes.func,
        })
    ).isRequired,
};
